import React from "react"

import { Subtract } from "utility-types"

import { DeviceInfo } from "./DeviceInfo"
import { DeviceInfoContext } from "./DeviceInfoContext"

export interface WithDeviceInfo {
  deviceInfo: DeviceInfo | undefined
}

/**
 * HoC function that injects DeviceInfo as `deviceInfo` property.
 *
 * @see https://github.com/typescript-cheatsheets/react-typescript-cheatsheet/blob/master/HOC.md
 */
export const withDeviceInfo = <
  S extends WithDeviceInfo = WithDeviceInfo,
  D = Subtract<S, WithDeviceInfo>
>(
  WrappedComponent: React.ComponentType<S>,
): React.FunctionComponent<D> => {
  const displayName = WrappedComponent.displayName || WrappedComponent.name || "Component"

  const wrapper: React.FunctionComponent<D> = (props: D)  => (
    <DeviceInfoContext.Consumer>
      {(deviceInfo) => (
        <WrappedComponent
          {...(props as unknown as S)}
          deviceInfo={deviceInfo}
        />
      )}
    </DeviceInfoContext.Consumer>
  )

  wrapper.displayName = `withDeviceInfo(${displayName})`

  return wrapper
}
